import React from 'react';
import NotificationsComponent from '../components/notifications/NotificationsPage';

const NotificationsPage = () => {
  return <NotificationsComponent />;
};

export default NotificationsPage;
